import {
  Button,
  InputAdornment,
  MenuItem,
  Modal,
  TextField,
  Box,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../../components/LoaderScreen";
import request from "../../../../Helpers/API";
import { red } from "@mui/material/colors";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import DeleteIcon from "@mui/icons-material/Delete";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { dark } from "@mui/material/styles/createPalette";

export const ModalAgregarNotificacion = ({
  open,
  handleClose,
  idencabezado,
  ObtenerListado,
  esEditar,
}) => {
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [notificacion, setNotificacion] = useState({
    mensaje: "",
    fechaInicio: "",
    fechaFin: "",
    hora: "",
    redireccion: "",
    departamento: "",
    tipo: "",
    estatus: true,
    dias: [],
  });

  const [moduloRedireccion, setModuloRedireccion] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);

  useEffect(() => {
    request
      .get(`ProgramarNotificacion/Modulos_Redireccion`)
      .then((result) => {
        // Actualizamos el estado con la fecha y hora separadas
        // console.log(result.departamentos);
        setModuloRedireccion(result.redirecciones);
        setDepartamentos(result.departamentos);
      })
      .catch((error) => {
        console.log("Error al obtener la notificación", error);
      });
  }, []);

  useEffect(() => {
    if (idencabezado !== -99) {
      request
        .get(`ProgramarNotificacion/BuscarID?iddetalle=${idencabezado}`)
        .then((result) => {
          // Extraer la fecha y la hora de result.fecha_evento
          const fecha = result.fecha_evento.split("T")[0]; // La fecha será la parte antes de la 'T'
          const hora = result.fecha_evento.split("T")[1]; // La hora será la parte después de la 'T'

          // Actualizamos el estado con la fecha y hora separadas
          setNotificacion({
            ...notificacion,
            mensaje: result.mensaje,
            departamento: result.iddepartamento,
            // fecha: fecha,
            fechaInicio: result.fecha_inicio,
            fechaFin: result.fecha_fin,
            hora: result.hora,
            redireccion: result.idmodulo,
            tipo: result.tipo_alerta,
            dias: result.dia ? result.dia.split(",") : [],
            duracion: result.frecuencia,
            estatus: result.estatus,
          });
        })
        .catch((error) => {
          console.log("Error al obtener la notificación", error);
        });
    } else {
      setNotificacion({
        ...notificacion,
        hora: new Date().toLocaleTimeString("es-MX", { hour12: false }),
      });
    }
  }, [idencabezado]);

  // Función para manejar el cambio de valores de los inputs
  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setNotificacion({
      ...notificacion,
      [id]: type === "checkbox" ? checked : value,
    });
  };

  useEffect(() => {
    // Cuando el tipo es EU, la fecha fin debe ser igual a fecha inicio
    if (notificacion.tipo === "EU" && notificacion.fechaInicio) {
      setNotificacion((prev) => ({
        ...prev,
        fechaFin: prev.fechaInicio,
      }));
    }
  }, [notificacion.tipo, notificacion.fechaInicio]);

  const onGuardar = () => {
    // console.log(notificacion)
    // Verifica que tanto la fecha como la hora estén presentes
    if (
      notificacion.departamento === undefined ||
      notificacion.departamento === null ||
      notificacion.departamento === 0 ||
      notificacion.departamento === ""
    ) {
      Swal.fire(
        "Error",
        "Debe seleccionar el departamento al que pertenece la notificacion",
        "error",
      );
      return;
    }
    if (
      notificacion.dias.length < 1 &&
      notificacion.tipo !== "IN" &&
      notificacion.tipo !== "EU"
    ) {
      Swal.fire(
        "Error",
        "Debe seleccionar al menos un dia para el envio.",
        "error",
      );
      return;
    }

    if (notificacion.fecha && notificacion.hora && notificacion.tipo === "F") {
      // const fechaConvenioDate = new Date(fechaConvenio);

      // Comparar la fecha y hora con la fecha actual
      if (notificacion.fechaInicio > notificacion.fechaFin) {
        // Si la fecha convenida es anterior a la fecha actual, mostrar un error
        Swal.fire(
          "Error",
          "La fecha inicio no puede ser posterior a la fecha fin.",
          "error",
        );
        return;
      }

      // Verificar si la hora es al menos 1 hora posterior a la hora actual
      const fechaLimite = new Date();
      fechaLimite.setHours(fechaLimite.getHours() + 1); // sumamos 1 hora a la fecha actual

      // Comprobamos si la fecha y hora proporcionadas son menores que el límite permitid

      // if (!isValidDate) {
      //     Swal.fire("Error", "La fecha y hora no son válidas.", "error");
      //     return;
      // }
    }

    if (notificacion.tipo !== "IN" && notificacion !== "EU") {
      if (
        notificacion.fechaInicio === "" ||
        notificacion.fechaInicio === undefined ||
        notificacion.fechaInicio === null
      ) {
        Swal.fire("Error", "Debe seleccionar una fecha de inicio", "warning");
        return;
      }

      if (
        notificacion.fechaFin === "" ||
        notificacion.fechaFin === undefined ||
        notificacion.fechaFin === null
      ) {
        Swal.fire("Error", "Debe seleccionar una fecha de fin", "warning");
        return;
      }

      if (
        notificacion.hora === "" ||
        (notificacion.hora === undefined) | (notificacion.hora === null)
      ) {
        Swal.fire("Error", "Debe seleccionar una Hora", "warning");
        return;
      }
    }

    if (notificacion.tipo === "EU") {
      if (
        notificacion.fechaInicio === "" ||
        notificacion.fechaInicio === undefined ||
        notificacion.fechaInicio === null
      ) {
        Swal.fire("Error", "Debe seleccionar una fecha de inicio", "warning");
        return;
      }
      if (
        notificacion.hora === "" ||
        notificacion.hora === undefined ||
        notificacion.hora === null
      ) {
        Swal.fire("Error", "Debe seleccionar una Hora", "warning");
        return;
      }
    }

    const fechaLocal = new Date();
    const fechaFormateada =
      fechaLocal.getFullYear() +
      "-" +
      String(fechaLocal.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(fechaLocal.getDate()).padStart(2, "0") +
      " " +
      String(fechaLocal.getHours()).padStart(2, "0") +
      ":" +
      String(fechaLocal.getMinutes()).padStart(2, "0") +
      ":" +
      String(fechaLocal.getSeconds()).padStart(2, "0");

    // Solo la hora: HH:mm:ss
    const horaFormateada =
      String(fechaLocal.getHours()).padStart(2, "0") +
      ":" +
      String(fechaLocal.getMinutes()).padStart(2, "0") +
      ":" +
      String(fechaLocal.getSeconds()).padStart(2, "0");

    const post = {
      idencabezado: idencabezado,
      mensaje: notificacion.mensaje,
      // fecha_evento: notificacion.tipo === "I" ? fechaFormateada : fechaConvenio,
      fecha_inicio: notificacion.fechaInicio,
      fecha_fin: notificacion.fechaFin,
      // repite: notificacion.repite,
      iddepartamento: notificacion.departamento,
      redireccion: notificacion.redireccion,
      hora: notificacion.hora,
      // duracion: notificacion.duracion,
      tipo: notificacion.tipo,
      dia: notificacion.dias.join(","),
    };

    const ruta =
      notificacion.tipo === "IN"
        ? "ProgramarNotificacion/GuardarInstantanea"
        : "ProgramarNotificacion";

    request
      .post(ruta, post)
      .then(async () => {
        setLoader({ ...loader, mostrar: false });
        handleClose();
        ObtenerListado();
        Swal.fire("NOTIFICACION", "Notificacion Guardada", "success");
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("NOTIFICACION", JSON.stringify(error), "error");
      });
  };

  const onPausar = () => {
    request
      .get(
        `ProgramarNotificacion/PausarNotificacion?idencabezado=${idencabezado}&estatus=${notificacion.estatus === false ? true : false}`,
      )
      .then(async () => {
        setLoader({ ...loader, mostrar: false });
        handleClose();
        if (notificacion.estatus === true)
          Swal.fire("NOTIFICACION", "Notificacion Pausada", "success");
        else Swal.fire("NOTIFICACION", "Notificacion Reanudada", "success");
        ObtenerListado();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("NOTIFICACION", JSON.stringify(error), "error");
      });
  };

  const onEliminar = () => {
    Swal.fire({
      title: "¿Desea eliminar esta notificación?",
      text: "Esta acción no se puede deshacer",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoader({ ...loader, mostrar: true });

        request
          .get(
            `ProgramarNotificacion/EliminarNotificacion?idencabezado=${idencabezado}`,
          )
          .then(() => {
            setLoader({ ...loader, mostrar: false });
            handleClose();
            Swal.fire(
              "NOTIFICACIÓN",
              "Notificación eliminada correctamente",
              "success",
            );
            ObtenerListado();
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("NOTIFICACIÓN", JSON.stringify(error), "error");
          });
      }
    });
  };

  // console.log(notificacion)

  return (
    <Modal open={open}>
      <div className="otros-modal">
        <LoaderScreen loader={loader} />
        <div className="otros-modal-title">
          <div className="filtro-soy-el-titulo-header">
            <h3>
              {esEditar ? "MODIFICAR NOTIFICACION" : "AGREGAR NOTIFICACION"}
            </h3>
          </div>
          <div
            className="cerrar-button"
            onClick={handleClose}
            style={{ cursor: "pointer" }}
          >
            X
          </div>
        </div>
        <div className="imagen-modal-soy-el-titulo-line">
          <div className="imagen-modal-soy-el-titulo-line-bl"></div>
          <div className="imagen-modal-soy-el-titulo-line-circle"></div>
          <div className="imagen-modal-soy-el-titulo-line-br"></div>
        </div>

        <div className="otros-modal-container">
          <div>
            <TextField
              fullWidth
              size="small"
              label="Departamento"
              variant="outlined"
              select
              type="text"
              value={notificacion.departamento}
              onChange={({ target }) => {
                setNotificacion({
                  ...notificacion,
                  departamento: target.value,
                });
              }}
              sx={{
                mb: 2,
                "& .MuiInputBase-root": {
                  height: "40px",
                },
              }}
            >
              {departamentos.map((dep, index) => (
                <MenuItem key={index} value={dep.iddepartamento}>
                  {capitalizePalabras(dep.nombre)}
                </MenuItem>
              ))}
            </TextField>
          </div>
          <div>
            <TextField
              fullWidth
              id="mensaje"
              label="Mensaje"
              type="text"
              value={notificacion?.mensaje}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
          </div>
          <div>
            <TextField
              fullWidth
              size="small"
              label="Reedireccion"
              variant="outlined"
              select
              type="text"
              value={notificacion.redireccion}
              onChange={({ target }) => {
                setNotificacion({ ...notificacion, redireccion: target.value });
              }}
              sx={{
                mb: 2,
                "& .MuiInputBase-root": {
                  height: "40px",
                },
              }}
            >
              {moduloRedireccion.map((red, index) => (
                <MenuItem key={index} value={red.idmodulo}>
                  {red.descripcion}
                </MenuItem>
              ))}
            </TextField>
          </div>

          <div className="titulo-selector">Tipo de notificación</div>
          <div className="selector-tipo">
            <div
              className={`tipo ${notificacion.tipo === "EU" ? "selected" : ""}`}
              onClick={() => setNotificacion({ ...notificacion, tipo: "EU" })}
            >
              Envío único
            </div>
            <div
              className={`tipo ${notificacion.tipo === "DI" ? "selected" : ""}`}
              onClick={() => setNotificacion({ ...notificacion, tipo: "DI" })}
            >
              Diario
            </div>
            <div
              className={`tipo ${notificacion.tipo === "DS" ? "selected" : ""}`}
              onClick={() => setNotificacion({ ...notificacion, tipo: "DS" })}
            >
              Cada 2 semanas
            </div>
            <div
              className={`tipo ${notificacion.tipo === "CM" ? "selected" : ""}`}
              onClick={() => setNotificacion({ ...notificacion, tipo: "CM" })}
            >
              Cada mes
            </div>
            <div
              className={`tipo ${notificacion.tipo === "IN" ? "selected" : ""}`}
              onClick={() => setNotificacion({ ...notificacion, tipo: "IN" })}
            >
              Instantaneas
            </div>
            {/* <div className={`tipo ${notificacion.tipo === "RA" ? "selected" : ""}`}
                            onClick={() => setNotificacion({ ...notificacion, tipo: "RA" })}>
                            Realizar acción
                        </div> */}
          </div>

          {notificacion.tipo !== "IN" && (
            <div>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  mt: 3,
                  mb: 2,
                }}
              >
                {/* FECHA INICIO */}
                <TextField
                  id="fechaInicio"
                  fullWidth
                  label="Fecha inicio"
                  type="date"
                  value={notificacion.fechaInicio || ""}
                  onChange={({ target }) =>
                    setNotificacion({
                      ...notificacion,
                      fechaInicio: target.value,
                    })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />

                {/* FECHA FIN */}
                {notificacion.tipo !== "EU" && (
                  <TextField
                    id="fechaFin"
                    fullWidth
                    label="Fecha fin"
                    type="date"
                    value={notificacion.fechaFin || ""}
                    onChange={({ target }) =>
                      setNotificacion({
                        ...notificacion,
                        fechaFin: target.value,
                      })
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                )}

                {/* HORA */}
                <TextField
                  id="hora"
                  fullWidth
                  label="Hora"
                  type="time"
                  value={notificacion.hora}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Box>
            </div>
          )}

          {notificacion.tipo !== "IN" && notificacion.tipo !== "EU" && (
            <>
              <div className="titulo-selector">Dias de envio</div>
              <div className="selector-dias">
                {[
                  { label: "Lunes", value: "LU" },
                  { label: "Martes", value: "MA" },
                  { label: "Miércoles", value: "MI" },
                  { label: "Jueves", value: "JU" },
                  { label: "Viernes", value: "VI" },
                  { label: "Sábado", value: "SA" },
                ].map((dia) => (
                  <div
                    key={dia.value}
                    className={`dia ${notificacion.dias.includes(dia.value) ? "selected" : ""}`}
                    onClick={() => {
                      const diasSeleccionados = notificacion.dias.includes(
                        dia.value,
                      )
                        ? notificacion.dias.filter((d) => d !== dia.value)
                        : [...notificacion.dias, dia.value];

                      setNotificacion({
                        ...notificacion,
                        dias: diasSeleccionados,
                      });
                    }}
                  >
                    {dia.label}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
        <div className="imagen-modal-button-container">
          <div className="right-buttons">
            <div className="left-actions">
              {esEditar && (
                <>
                  {notificacion.estatus === true ? (
                    <div
                      className="pausar-button"
                      style={{ cursor: "pointer" }}
                      onClick={onPausar}
                    >
                      <PauseCircleOutlineIcon />
                      Pausar envío
                    </div>
                  ) : (
                    <div
                      className="pausar-button"
                      style={{ cursor: "pointer" }}
                      onClick={onPausar}
                    >
                      <PlayCircleOutlineIcon />
                      Reanudar envío
                    </div>
                  )}
                  <div
                    className="eliminar-button"
                    onClick={onEliminar}
                    style={{ cursor: "pointer" }}
                  >
                    <DeleteIcon />
                    Eliminar
                  </div>
                </>
              )}
            </div>

            <div className="right-actions">
              <div
                className="agregar-button"
                onClick={onGuardar}
                style={{ cursor: "pointer" }}
              >
                <AddCircleOutlineIcon />
                Agregar
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
